module.exports = __webpack_public_path__ + "img/availabilty&Reliability.37b8f375.svg";